export const countryCodes = ['AR', 'CL', 'CO', 'MX', 'UY', 'US', 'ES', 'BR', 'PE', 'PY', 'EC']
export const noIdentityDocument = ['MX']
